import React from 'react';

import { HistorySkeletonItem } from '../styles';

const PropertyHistorySkeleton: React.FC = () => (
  <>
    <HistorySkeletonItem />
    <HistorySkeletonItem />
    <HistorySkeletonItem />
    <HistorySkeletonItem />
  </>
);

export default PropertyHistorySkeleton;
